/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useState } from 'react';
import { useSelect } from '../../../../../utils/selector.utils';
import { useDispatch } from 'react-redux';
import { ICalendarWidgetListProps } from './types';
import { openDialog } from '../../../../../app/dialog/dialog.actions';
import { userSettingsPageSelectors } from '../../../../../app/page/page-storage/user-settings/user-settings.selectors';

export const CalendarWidgetList: FunctionComponent<ICalendarWidgetListProps> = ({ calendarItemId }) => {
  const dispatch = useDispatch();

  const googleCalendarEmbedUrl = useSelect(userSettingsPageSelectors.selectGoogleCalendarEmbedUrl);

  const openNewWindow = useCallback(() => {
    dispatch(openDialog('googleCalendarEmbedUrlFormDialog'));
  }, [dispatch]);

  const userAgent = navigator.userAgent.toLowerCase();
  const browserIsSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
  const showWarning = localStorage.getItem('show_calendar_warning');
  const [isSafariWarningActive, setIsSafariWarningActive] = useState(showWarning === null);
  const handleSafariWarningClose = useCallback(() => {
    setIsSafariWarningActive(false);
    localStorage.setItem('show_calendar_warning', '');
  }, [setIsSafariWarningActive]);

  return (
    <>
      {isSafariWarningActive && browserIsSafari && (
        <div className="mini-popup mb-2 border-radius-1" style={{ backgroundColor: '#eff1f3' }}>
          <div className="mini-popup-header">
            <span className="close_mini_popup" onClick={handleSafariWarningClose}>
              ×
            </span>
          </div>
          <div className="mini-popup-body">
            <p className="ln mb-2 darkGray">
              If your calendar is not visible after signing in to Google, ensure that &apos;Prevent Cross-Site
              Tracking&apos; is disabled in your Safari settings. This feature can be found under &apos;Settings &gt;
              Safari &gt; Privacy & Security&apos;.
            </p>
          </div>
        </div>
      )}

      <div className={`panel-body ${googleCalendarEmbedUrl ? 'responsiveCal' : ''}`} style={{ height: '100%' }}>
        {googleCalendarEmbedUrl ? (
          <iframe src={googleCalendarEmbedUrl} title="googleCalendarEmbedIframe" />
        ) : (
          <p>
            Please, link your Google calendar{' '}
            <a target="_blank" onClick={openNewWindow} style={{ cursor: 'pointer' }}>
              here
            </a>
            .
          </p>
        )}
      </div>
    </>
  );
};
